import { BudgetLineParameterDto } from 'api/budgets/models/BudgetLineParameterDto';
import DateInput from 'common/components/dateInput/DateInput';

interface Props {
    parameter: BudgetLineParameterDto;
    disabled: boolean;
    onChange: (parameter: Partial<BudgetLineParameterDto>, calculateTotals: boolean) => void;
}

function ParameterDate({ parameter, disabled, onChange }: Props): JSX.Element | null {
    const handleChange = (date: Date | null | undefined) => {
        if (date) {
            onChange({ date: date.toISOString() }, false);
        } else {
            onChange({ date: null }, false);
        }
    };

    const dateValue = parameter.date ? new Date(parameter.date) : null;

    return (
        <DateInput
            value={dateValue}
            onChange={handleChange}
            disabled={disabled}
        />
    );
}

export default ParameterDate;
